import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colours, customFonts } from "../../constants/css";
var SelectGrid = styled.div.withConfig({
  displayName: "MultiSelect__SelectGrid",
  componentId: "sc-1oxl7wk-0"
})(["display:flex;border-radius:4px;> *{flex-basis:calc(100% / ", ");border:2px solid ", ";&:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px;}&:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px;}", "}"], function (props) {
  return props.columns;
}, colours.qantasLightGrey, function (props) {
  return props.columns === 1 ? "\n      &:not(:last-child) {\n        border-bottom-width: 0;\n      }\n    " : "\n      &:not(:last-child) {\n        border-right-width: 0;\n      }\n    ";
});
var Item = styled.button.withConfig({
  displayName: "MultiSelect__Item",
  componentId: "sc-1oxl7wk-1"
})(["padding:0;margin:0;color:", ";font-size:inherit;font-family:", ";height:45px;text-align:center;cursor:pointer;background:", ";border-left:4px solid ", ";"], colours.qantasCharcoal, customFonts.ciutadellaMed, function (props) {
  if (props.tabs) {
    return props.isSelected ? colours.qantasAqua : colours.qantasListTab;
  }
  return props.isSelected ? colours.qantasWhite : colours.qantasListTab;
}, function (props) {
  return props.isSelected && !props.tabs ? colours.qantasAqua : 'none';
});
var MultiSelect = /*#__PURE__*/function (_Component) {
  function MultiSelect(props) {
    var _this;
    _classCallCheck(this, MultiSelect);
    _this = _callSuper(this, MultiSelect, [props]);
    _this.selectItem = function (itemIndex) {
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        items = _this$props.items;
      _this.setState({
        selectedIndex: itemIndex
      });
      onSelect(items[itemIndex].value);
    };
    _this.state = {
      selectedIndex: _this.props.defaultIndex
    };
    return _this;
  }
  _inherits(MultiSelect, _Component);
  return _createClass(MultiSelect, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextIndex = nextProps.defaultIndex;
      var currentIndex = this.props.defaultIndex;
      if (nextIndex === currentIndex) {
        return;
      }
      this.setState({
        selectedIndex: nextIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        items = _this$props2.items,
        columns = _this$props2.columns,
        className = _this$props2.className,
        tabs = _this$props2.tabs;
      var selectedIndex = this.state.selectedIndex;
      return __jsx(SelectGrid, {
        className: className,
        columns: columns
      }, items.map(function (item, i) {
        return __jsx(Item, {
          index: i,
          key: item.value,
          isSelected: i === selectedIndex,
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.selectItem(i);
          },
          tabIndex: "0",
          tabs: tabs
        }, item.name);
      }));
    }
  }]);
}(Component);
MultiSelect.defaultProps = {
  defaultIndex: 0,
  columns: 1,
  className: '',
  tabs: false
};
export default MultiSelect;